// Locale is a unique combination of Country and Language
export enum LocaleId {
  default,
  US = 1,
  ChinaChinese = 3,
  ChinaEnglish = 4,
  IndiaEnglish = 5,
  UkEnglish = 7,
  NlEnglish = 8,
  ItalyEnglish = 10,
  FinlandEnglish = 11,
  SwedenEnglish = 12,
  NorwayEnglish = 14,
  PolandEnglish = 15,
  AustraliaEnglish = 28,
  NewZealandEnglish = 29,
  PolandPolish = 31,
  ItalyItalian = 32,
  SwedenSwedish = 33,
  FinlandFinnish = 34,
  NorwayNorwegian = 35,
  NlDutch = 37,
  HongKongChinese = 39,
  HongKongEnglish = 40,
  SpainSpanish = 47,
  AustriaEnglish = 16,
  AustriaGerman = 49,
  Germany = 26,
  GermanyGerman = 50
}
